import { normalizeError } from './api-error';
import { rawClient } from './raw-client';
import { sessionEndpoints, type SessionResponse } from './session.endpoints';
import { applySession } from './session-apply';

// 구 웹 로그인 이어받기(DD-88, 2027-01-31 까지). 기한이 지나면 이 파일을 지운다.
// 부팅 때 쿠키 갱신이 거절되면 구 토큰(`legacy-session.ts`)을 새 세션(리프레시 쿠키 + 액세스 토큰)으로 바꾼다.
// 토큰은 로그에 남기지 않는다.

/**
 * 결과 3분류(토큰 갱신과 같다)
 * - ok          : 새 세션을 받아 store 에 반영했다
 * - rejected    : 서버가 거절했다(400 · 401 · 403). 다시 시도해도 소용없다
 * - unreachable : 서버에 닿지 못했다(네트워크 오류 · 타임아웃 · 5xx · 그 밖). 다음 부팅에 다시 시도한다
 */
export type LegacyExchangeOutcome = 'ok' | 'rejected' | 'unreachable';

export async function exchangeLegacySession(token: string): Promise<LegacyExchangeOutcome> {
  try {
    const { data } = await rawClient.request<SessionResponse>({
      method: sessionEndpoints.legacyExchange.method,
      url: sessionEndpoints.legacyExchange.path,
      data: { token },
    });
    applySession(data);
    return 'ok';
  } catch (caught) {
    const { status } = normalizeError(caught);
    return status === 400 || status === 401 || status === 403 ? 'rejected' : 'unreachable';
  }
}
